import { useState } from "react";

import { useUserContacts } from "@/shared/hooks/useUserContacts";
import { contactFullName } from "@/shared/utils/contactUtils";
import { splitName } from "@/shared/utils/names";

interface InviteeErrors {
  fullName?: string;
  email?: string;
}

export function useInviteeForm(initialName: string) {
  const { contacts, saveContactAsync } = useUserContacts();
  const [contactId, setContactId] = useState<number | null>(null);
  const [fullName, setFullName] = useState(initialName);
  const [relationship, setRelationship] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [errors, setErrors] = useState<InviteeErrors>({});

  const pickContact = (id: number | null) => {
    const contact = contacts.find((c) => c.id === id);
    setContactId(id);
    setFullName(contact ? contactFullName(contact) : initialName);
    setRelationship(contact?.relationship ?? "");
    setEmail(contact?.email ?? "");
    setPhone(contact?.phone ?? "");
    setErrors({});
  };

  const saveContact = () => {
    const { firstName, surName } = splitName(fullName);
    return saveContactAsync(contactId, {
      first_name: firstName,
      last_name: surName,
      email: email.trim().toLowerCase(),
      phone: phone.trim() || null,
      relationship: relationship || null,
    });
  };

  return {
    contactId,
    pickContact,
    fullName,
    setFullName,
    relationship,
    setRelationship,
    email,
    setEmail,
    phone,
    setPhone,
    errors,
    setErrors,
    saveContact,
  };
}
